// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"4cecf954e7d82c3cf5e9","245":"d4339c5161277ce94893","452":"a15d116e3074315bbb49","453":"ecd05e68eb2784692545"}[chunkId] + ".js";
};